import styled from 'styled-components';

const CampaignAdditionalDetailsStyle = styled.div`
  margin-bottom: 16px;

  .accordion__content--open {
    padding: 0;
  }

  .accordion__content--open:has(.campaignAdditionalDetails__templateMailingSelector),
  .accordion__content--open:has(.campaignAdditionalDetails__templateMailingSelector) .accordion__contentInner {
    overflow: visible;
  }

  .accordion__content:not(.accordion__content--open) {
    padding: 0;
    height: 0;
    overflow: hidden;
  }

  .campaignAdditionalDetails {
    &__additionalDetailsLabel {
      margin-bottom: 10px;
      color: ${props => props.theme.textColorDark};
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeM};
    }

    &__additionalDetailsContent {
      padding-left: 5px;

      input[type="checkbox"] {
        margin-bottom: 2px;
      }
    }

    &__forecastConfigContainer, &__testConfigContainer {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 600px;
      gap: var(--spacing-8);
    }

    &__templateCampaignDetailsContainer {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: var(--spacing-16);
      margin: var(--spacing-8) 0;
    }

    &__dataProvider {
      display: inline-flex;
      align-items: center;
      width: 100%;
      gap: var(--spacing-8);
      
      &Check {
        .checkboxText {
          padding-bottom: 2px;
        }
      }
      
      &Input {
        max-width: 185px;
        padding-left: 17px;
      }
      
      &Selector {
        min-width: 250px;
        max-width: 300px;
      }
    }

    &__predicioPixelUsage {
      max-width: 185px;
    }

    &__dataProvidersContainer {
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      gap: var(--spacing-8);
    }

    &__templateMailingSelector {
    }
  }

`;

export { CampaignAdditionalDetailsStyle };
